import  request from '@/utils/http'
import { asyncRoutes } from '@/router/routes/asyncRoutes'
import { menuDataToRouter } from '@/router/utils/menuToRouter'
import { AppRouteRecord } from '@/types/router'

interface MenuResponse {
  menuList: AppRouteRecord[]
}

// 菜单接口
export const menuService = {
  async getMenuList(delay = 300): Promise<MenuResponse> {
    try {
      // 模拟接口返回的菜单数据
      // const menuData = asyncRoutes
      // 处理菜单数据
      // const menuList = menuData.map((route) => menuDataToRouter(route))
      // 模拟接口延迟
      // await new Promise((resolve) => setTimeout(resolve, delay))
      const res = await request.get<AppRouteRecord[]>({
        url: '/api/user/menus'
      })
      console.log('菜单数据:',res)
      // 处理菜单数据
      const menuList = res.map((route) => menuDataToRouter(route))

      return { menuList }
    } catch (error) {
      throw error instanceof Error ? error : new Error('获取菜单失败')
    }
  }
}
// 获取所有的菜单
export const getMenusAll = (params: any) => {
  return request.get({ url: '/api/menus/all',params})
}
// 获取菜单列表
export const getMenusList = (params: any) => {
  return request.get({ url: '/api/menus/tree',params})
}
export const addMenus = (params: any) => {
    return request.post({ url: '/api/menus/add',data:params})
}
export const saveMenus = (params: any) => {
    return request.post({ url: '/api/menus/save',data:params})
}
export const deleteMenus = (params: any) => {
    return request.post({ url: '/api/menus/delete',data:params})
}

